const Operations = [
  {
    id: 1,
    OperationType: 'SO',
    OperationName: 'Sales Order List',
    OperationView: 'salesOrdersDataViewList',
  },
  {
    id: 2,
    OperationType: 'PO',
    OperationName: 'Purchase Order List',
    OperationView: 'purchaseOrdersViewList',
  },
  {
    id: 3,
    OperationType: 'WH',
    OperationName: 'Wharehouse Receipt List',
    OperationView: 'whareHouseReceiptViewList',
  },
  {
    id: 4,
    OperationType: 'CR',
    OperationName: 'Cargo Release List',
    OperationView: 'cargoReleaseViewList',
  },
  /* {
    id: 5,
    OperationType: "ID",
    OperationName: "Items Definitions List"
    }, */ {
    id: 6,
    OperationType: 'WI',
    OperationName: 'Commodity List',
    OperationView: 'commodityViewList',
  },
  {
    id: 7,
    OperationType: 'IEN',
    OperationName: 'Entities List',
    OperationView: 'EntitiesDataViewList',
  },
  {
    id: 8,
    OperationType: 'SH',
    OperationName: 'Shipments List',
    OperationView: 'ShipmentsDataViewList',
  },
  {
    id: 9,
    OperationType: 'PK',
    OperationName: 'Pickup Order List',
    OperationView: 'pickupOrdersDataViewList',
  },
  {
    id: 10,
    OperationType: 'IV',
    OperationName: 'Item Definitions List',
    OperationView: 'ItemDefinitionsList',
  },
  {
    id: 11,
    OperationType: 'IN',
    OperationName: 'Invoices List',
    OperationView: 'invoicesDataViewList',
  },
  {
    id: 12,
    OperationType: 'QT',
    OperationName: 'Quotation List',
    OperationView: 'quotationsDataViewList',
  },
  {
    id: 13,
    OperationType: 'BK',
    OperationName: 'Booking List',
    OperationView: 'bookingDataViewList',
  },
];

export default Operations;
